import React, { useState, useEffect } from 'react';
import Vimeo from '@u-wave/react-vimeo';
// import classes from './VideoPlayer.module.scss';

const VideoPlayer = ({ video, width, className, style }) => {
  const [show, setShow] = useState(false);

  // useEffect(()=> {
  //   const timeout = setTimeout(()=> {
  //     setShow(true);
  //   }, 100);
  //   return ()=> clearTimeout(timeout);
  // }, []);

  useEffect(() => {
    setShow(false);
    const timeout = setTimeout(()=> {
      setShow(true);
    }, 100);
    return ()=> clearTimeout(timeout);
  }, [width]);

  const rootClass = ['vimeo-video'];
  if (className) rootClass.push(className);

  return (
    <div 
      // onMouseEnter={()=> document.body.style = 'overflow: hidden'}
      // onMouseLeave={()=> document.body.style = 'overflow: auto'}
      style={{ width }}
    >
      {show && <Vimeo
          video={video}
          width={width}
        /> }
    </div>
  );
}

export default VideoPlayer;